import { render, staticRenderFns } from "./ReportsSurgeryOperations.vue?vue&type=template&id=1cf42458&scoped=true"
import script from "./ReportsSurgeryOperations.vue?vue&type=script&lang=js"
export * from "./ReportsSurgeryOperations.vue?vue&type=script&lang=js"
import style0 from "./ReportsSurgeryOperations.vue?vue&type=style&index=0&id=1cf42458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf42458",
  null
  
)

export default component.exports